module.exports = __webpack_public_path__ + "static/media/icon-mobile.414c05a9.svg";